import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-03816fc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-tooltip"];
const _hoisted_2 = {
    key: 0,
    class: "fas fa-info-circle"
};
const _hoisted_3 = {
    key: 1,
    class: "fas fa-check-circle"
};
const _hoisted_4 = {
    key: 2,
    class: "fas fa-exclamation-circle"
};
const _hoisted_5 = {
    key: 3,
    class: "fas fa-times-circle is-danger"
};
const _hoisted_6 = {
    key: 4,
    class: "ml-1 label"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'ValidationIndicator',
    props: {
        type: {},
        label: {},
        tooltip: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "data-tooltip": _ctx.tooltip,
                class: _normalizeClass(["validationIndicator ml-1 has-tooltip-multiline", _ctx.type])
            }, [
                (_ctx.type == 'info')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                    : _createCommentVNode("", true),
                (_ctx.type == 'success')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                    : _createCommentVNode("", true),
                (_ctx.type == 'warning')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                    : _createCommentVNode("", true),
                (_ctx.type == 'error')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : _createCommentVNode("", true),
                (_ctx.label && _ctx.label.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.label), 1))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_1));
        };
    }
});
